<nav class="next-nav">
  <ol class="next-nav__list">
    <li *ngFor="let step of wizardService.stepsForNavigation; let i = index"
        class="next-nav__item"
        [ngClass]="{
          'next-nav__item--allowed': isStepAllowed(step),
          'next-nav__item--completed': isStepCompleted(step),
          'next-nav__item--active': isStepActive(step)
        }"
        (click)="wizardService.navigateToClickedStep(step)">
      {{ step.additionalInfo.stepName }}
    </li>
  </ol>
</nav>
